import type { EcosystemPageProps, PageProps } from "@/types";
import React, { FC, useRef } from "react";
import {
  EcosystemCrossBorderPayments,
  EcosystemHero,
  EcosystemNextPages,
} from "../ecosystem";
import { ContentManager } from "../content-manager";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";

export const Ecosystem: FC<PageProps<EcosystemPageProps>> = (props) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <div>
      <EcosystemHero
        label={props.meta.translation.ecosystem.hero.label}
        title={props.data.title}
        description={props.data.description}
        cover={props.data.cover}
      />
      <EcosystemCrossBorderPayments
        content={props.data.crossBorderPaymentsContent}
        cards={props.data.crossBorderPaymentsCards}
      />
      <div ref={ref}>
        <SplitTextAnimation
          htmlElement={
            <ContentManager
              content={props.data.diverseNeeds}
              className="ecosystemDiverseNeeds--content"
            />
          }
          isInView={isInView}
        />
      </div>
      <EcosystemNextPages nextPages={props.data.nextPages} />
    </div>
  );
};
